import React, { useEffect, useState } from 'react'
import ReactLoading from 'react-loading'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../service/ApiService'
import { Modal } from '../../Shared/Modal'
import { PolicyContent, PolicyLoading } from './styles'

export const PrivacyPolicyModal = ({ open, onClose }) => {
  const { t } = useTranslation()
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)
  const currentLng = localStorage.getItem('i18nextLng') || 'ar'

  useEffect(() => {
    if (!open) return

    const fetchPolicy = async () => {
      setLoading(true)
      const res = await ApiService('/policy', {}, 'get')
      if (res?.success) {
        setContent(currentLng === 'en' ? res.policy_en : res.policy_ar)
      } else {
        setContent('')
      }
      setLoading(false)
    }

    fetchPolicy()
  }, [open, currentLng])

  const modalContent = (
    <PolicyContent>
      {loading ? (
        <PolicyLoading>
          <ReactLoading type="bubbles" color="#9c5a2e" height={50} width={50} />
        </PolicyLoading>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </PolicyContent>
  )

  return (
    <Modal
      open={open}
      title={t('Privacy Policy')}
      onClose={onClose}
      closeOnBackdrop
      width="720px"
      padding="20px 24px"
    >
      {modalContent}
    </Modal>
  )
}
